import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        evaluationGroup: '=',
        bulkIds: '=',
        list: '=',
        classifiers: '=',
        sites: '='
    },
    template: `
        <div class="heading01">
            <h2>{{ 'evaluation.Participants' | translate }}</h2>
            <ul class="actions01">
                <li class="separated" ng-if="!vm.isDeadlinePassed()"><a ng-click="vm.addParticipants('EVALUATEE')" class="btn add">{{ 'evaluation.Add evaluatees' | translate }}</a></li>
                <li ng-if="false">
                    <span class="text">{{ 'evaluation.Group by' | translate }}</span>
                    <ul class="checkboxes04">
                        <li>
                            <label>
                                <input type="radio" ng-change="vm.toggleTable()" ng-model="vm.groupBy" value="{{ vm.EVALUATION_GROUPED_TYPE_ENUM.KEYS.EVALUABLE }}">
                                <span>{{ 'evaluation.Evaluatee' | translate }}</span>
                            </label>
                        </li>
                        <li>
                            <label>
                                <input type="radio" ng-change="vm.toggleTable()" ng-model="vm.groupBy" value="{{ vm.EVALUATION_GROUPED_TYPE_ENUM.KEYS.EVALUATOR }}">
                                <span>{{ 'evaluation.Evaluator' | translate }}</span>
                            </label>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
        <div style="margin-top:20px; position:relative; height:200px" ng-if="vm.list.loading">
            <div class="loader02">{{ 'evaluation.Loading participants' | translate }}</div>
        </div>
        <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
        <div class="well"ng-if="vm.list.items.length && !vm.list.loading">
            <table class="data01" datatable dt-options="vm.DATATABLES">
                <thead>
                <tr>
                    <th class="toggle">
                        <a class="toggle toggle-open" ng-click="vm.toggleTabs()" ng-if="vm.tabsOpened === true">Hide</a>
                        <a class="toggle toggle-closed" ng-click="vm.toggleTabs()" ng-if="vm.tabsOpened === false">Show</a>
                    </th>
                    <th class="w1p">
                        <input ng-model="vm.checked" ng-click="vm.toggleAll()" type="checkbox">
                    </th>
                    <th>{{ 'evaluation.Firstname' | translate }}</th>
                    <th>{{ 'evaluation.Lastname' | translate }}</th>
                    <th ng-if="vm.EVALUATION_GROUPED_TYPE_ENUM.KEYS.EVALUABLE === vm.groupBy">{{ 'evaluation.Relation to evaluator' | translate }}</th>
                    <th ng-if="vm.EVALUATION_GROUPED_TYPE_ENUM.KEYS.EVALUATOR === vm.groupBy">{{ 'evaluation.Relation to evaluatee' | translate }}</th>
                    <th>{{ 'evaluation.Status' | translate }}</th>
                    <th>{{ 'evaluation.Last reminder' | translate }}</th>
                    <th>{{ 'evaluation.Report last sent' | translate }}</th>
                    <th style="display:block!important;">&nbsp;</th>
                    <!-- <th>&nbsp;</th> -->
                </tr>
                </thead>
                <tbody ng-repeat="(index, evaluator) in vm.list.items">
                    <tr>
                        <td class="toggle">
                            <a class="toggle toggle-open" ng-if="vm.opened[$index] === true" ng-click="vm.toggle($index); vm.opened[$index] = !vm.opened[$index]">Hide</a>
                            <a class="toggle toggle-closed" ng-if="vm.opened[$index] === false" ng-click="vm.toggle($index); vm.opened[$index] = !vm.opened[$index]">Show</a>
                        </td>
                        <td class="w1p" ng-if="vm.isDeadlinePassed()">
                            <input type="checkbox" ng-checked="vm.isChecked(evaluator.id)" ng-click="$event.stopPropagation();vm.toggleCheckBox(evaluator.id)">
                        </td>
                        <td class="w1p" ng-if="!vm.isDeadlinePassed()">
                        </td>
                        <td><a ng-click="vm.editParticipants()">{{evaluator.user.firstName}}</a></td>
                        <td><a ng-click="vm.editParticipants()">{{evaluator.user.lastName}}</a></td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>{{ vm.MomentService.formatTimeStamp(evaluator.reportSentAt) }}</td>
                        <td class="blur actions">
                            <a class="btn view" ng-if="!vm.groupedByEvaluator && vm.isDeadlinePassed() && evaluator.evaluableId" target="_blank"
                            ui-sref="evaluation.report({
                                guid: evaluator.guid,
                                comparisonGuid: evaluator.comparisonGuid
                            })">{{ 'evaluation.View report' | translate }}</a>
                            <a class="btn add" ng-if="!vm.isDeadlinePassed()" target="_blank"
                                ng-click="vm.addParticipants('EVALUATOR', evaluator.id)">{{ 'evaluation.Add evaluators' | translate }}</a>
                            <a class="btn delete"
                                ng-if="!vm.isReadOnly"
                                ng-click="vm.removeParticipant(evaluator, evaluator.evaluableId, 'EVALUATEE')"
                            >{{ 'general.Remove' | translate }}</a>
                        </td>
                        <!-- <td class="actions"></td> -->
                    </tr>
                    <tr ng-if="evaluatee.firstName" ng-repeat="evaluatee in evaluator.relations" ng-hide="vm.opened[index] === false" class="level02">
                        <td></td>
                        <td ng-if="!vm.isDeadlinePassed()">
                            <input type="checkbox" ng-checked="vm.isChecked(evaluatee.id)" ng-click="$event.stopPropagation();vm.toggleCheckBox(evaluatee.id)">
                        </td>
                        <td class="w1p" ng-if="vm.isDeadlinePassed()">
                        </td>
                        <td><a ng-click="vm.editParticipants()">{{evaluatee.user.firstName}}</a></td>
                        <td><a ng-click="vm.editParticipants()">{{evaluatee.user.lastName}}</a></td>
                        <td>{{vm.EVALUATION_ROLE_ENUM.LABELS[evaluatee.role]}}</td>
                        <td>
                            <span ng-if="evaluatee.status === vm.EVALUATION_STATUS_ENUM.KEYS.COMPLETED" class="status status-ok">
                                {{vm.EVALUATION_STATUS_ENUM.LABELS.COMPLETED}}
                                <small>
                                    &nbsp;{{ vm.MomentService.formatTimeStamp(evaluatee.formSubmission.finishTime) }}
                                </small>
                            </span>
                            <span ng-if="evaluatee.status === vm.EVALUATION_STATUS_ENUM.KEYS.NOT_COMPLETED"
                            class="status status-warn">{{vm.EVALUATION_STATUS_ENUM.LABELS.NOT_COMPLETED}}</span>
                            <span ng-if="evaluatee.status === vm.EVALUATION_STATUS_ENUM.KEYS.NOTIFICATION_NOT_SENT"
                            class="status status-error">{{vm.EVALUATION_STATUS_ENUM.LABELS.NOTIFICATION_NOT_SENT}}</span>
                        </td>
                        <td>{{ vm.MomentService.formatTimeStamp(evaluatee.evaluatorEmailSentAt) }}</td>
                        <td>&nbsp;</td>
                        <td class="blur actions">
                            <a class="btn view" ng-if="vm.groupedByEvaluator && vm.isDeadlinePassed()" target="_blank"
                                ui-sref="evaluation.report({
                                guid: evaluatee.guid,
                                comparisonGuid: evaluatee.comparisonGuid
                                })">{{ 'evaluation.View report' | translate }}
                            </a>
                            <a class="btn delete"
                                style="float:right"
                                ng-if="!vm.isReadOnly"
                                ng-click="vm.removeParticipant(evaluatee, evaluatee.evaluatorId, 'EVALUATOR')"
                                >{{ 'general.Remove' | translate }}
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    `
})
export default class {
    constructor ($rootScope, $scope, $translate, toastr, lodash, DATATABLES, ListFactory, ModalService, EvaluationGroupEvaluationResource,
                MomentService, EVALUATION_GROUPED_TYPE_ENUM, EVALUATION_STATUS_ENUM, EVALUATION_ROLE_ENUM, EvaluationGroupResource) {
        this.lodash = lodash;
        this.toastr = toastr;
        this.$translate = $translate;
        this.MomentService = MomentService;
        this.ListFactory = ListFactory;
        this.ModalService = ModalService;
        this.EvaluationGroupEvaluationResource = EvaluationGroupEvaluationResource;
        this.EvaluationGroupResource = EvaluationGroupResource;
        this.EVALUATION_GROUPED_TYPE_ENUM = EVALUATION_GROUPED_TYPE_ENUM;
        this.EVALUATION_STATUS_ENUM = EVALUATION_STATUS_ENUM;
        this.EVALUATION_ROLE_ENUM = EVALUATION_ROLE_ENUM;
        this.DATATABLES = DATATABLES;
        this.groupBy = EVALUATION_GROUPED_TYPE_ENUM.KEYS.EVALUABLE;
        this.toggleTable();
        this.tabsOpened = true;

        const listener = $rootScope.$on('evaluation:reloadList', () => {
            this.toggleTable();
        });
        $scope.$on('$destroy', listener);
    }

    $onInit () {
        this.allIds = [];
        this.groupedByEvaluator = this.groupBy === this.EVALUATION_GROUPED_TYPE_ENUM.KEYS.EVALUATOR;
    }

    isDeadlinePassed () {
        return this.MomentService.isPassedTimeStamp(this.evaluationGroup.deadline);
    }

    toggleTabs () {
        this.tabsOpened = !this.tabsOpened;
        this.populateRowOpenedStates(this.tabsOpened);
    }

    toggleTable () {
        if (this.groupBy === this.EVALUATION_GROUPED_TYPE_ENUM.KEYS.EVALUABLE) {
            this.list = this.ListFactory.createWithPagination(this.EvaluationGroupEvaluationResource.evaluableGrouped.bind(this.EvaluationGroupEvaluationResource));
        }
        else if (this.groupBy === this.EVALUATION_GROUPED_TYPE_ENUM.KEYS.EVALUATOR) {
            this.list = this.ListFactory.createWithPagination(this.EvaluationGroupEvaluationResource.evaluatorGrouped.bind(this.EvaluationGroupEvaluationResource));
        }
        this.list.fetch({ evaluationGroupId: this.evaluationGroup.id, pageSize: 0 }).then(() => {
            this.groupedByEvaluator = this.groupBy === this.EVALUATION_GROUPED_TYPE_ENUM.KEYS.EVALUATOR;
            this.populateRowOpenedStates(true);
            this.allIds = this.lodash.map(this.list.items, (item) => item.id);
            this.toggleAll();
        });
    }

    populateRowOpenedStates (value) {
        this.opened = Array.apply(null, new Array(this.list.items.length)).map(Boolean.prototype.valueOf, value);
    }

    toggleAll () {
        this.bulkIds = [];
        this.populateRowOpenedStates(true);
        const onlyEvaluatees = this.isDeadlinePassed();
        if (this.checked) {
            this.lodash.forEach(this.list.items, evaluation => {
                // add all evaluatees
                if (onlyEvaluatees) {
                    this.bulkIds.push(evaluation.id);
                }
                // add all evaluators
                else {
                    this.lodash.forEach(evaluation.relations, relation => {
                        if (relation.evaluatorId) {
                            this.bulkIds.push(relation.id);
                        }
                    });
                }
            });
        }
    }

    isChecked (id) {
        return this.lodash.includes(this.bulkIds, id);
    }

    toggleCheckBox (id) {
        if (this.isChecked(id)) {
            this.lodash.pull(this.bulkIds, id);
            this.checked = false;
        }
        else {
            this.bulkIds.push(id);
        }
    }

    addParticipants (type, evaluationId = null) {
        const { evaluationGroup, classifiers, sites } = this;
        this.ModalService.open({
            animation: true,
            size: 'xlarge',
            template: `
                <modals-evaluation-participant
                    evaluation-group="vm.evaluationGroup"
                    classifiers="vm.classifiers"
                    sites="vm.sites"
                    uib-modal-instance="vm.$uibModalInstance"
                    type="vm.type"
                    evaluation-id="vm.evaluationId"
                    class="wrapper"
                />`,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.evaluationGroup = evaluationGroup;
                this.classifiers = classifiers;
                this.sites = sites;
                this.type = type;
                this.evaluationId = evaluationId;
            }
        }).then(() => {
            this.reload().then((updatedEvaluationGroup) => {
                this.evaluationGroup = updatedEvaluationGroup;
                this.toggleTable();
            });
        });
    }

    reload () {
        return this.EvaluationGroupResource.get({
            id: this.evaluationGroup.id,
            expand: 'form,completedEvaluationCount,notCompletedEvaluationCount,activeI18n,evaluationGroupI18ns'
        }).$promise;
    }

    removeParticipant (evaluation, userId, type) {
        const msg = type === 'EVALUATOR'
            ? this.$translate.instant('evaluationGroup.Remove evaluator?')
            : this.$translate.instant('evaluationGroup.Remove evaluatee?');
        this.ModalService.confirm(msg, 'medium')
            .then(() => {
                this.EvaluationGroupResource.removeParticipants(
                    { id: this.evaluationGroup.id }, { ids: [userId], evaluationId: evaluation.id, requestType: type }
                ).$promise
                    .then(() => {
                        this.toastr.success(this.$translate.instant('survey.Participant removed'));
                        this.reload().then((updatedEvaluationGroup) => {
                            this.evaluationGroup = updatedEvaluationGroup;
                            this.toggleTable();
                        });
                    })
                    .catch((response) => {
                        this.toastr.error(response.data[0].message);
                    });
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/evaluation/view/participants/index.js